import React from 'react'
import {
  IonImg
} from '@ionic/react'
import RssButton from '../../core/player-parts/RssButton'
import SimpleBar from 'simplebar-react'
import './styles.scss'

const RssChapterCard = (props) => {
  const { chapter, rssTitle } = props
  return (
    <div
      className='rss-chapter-card'
      itemScope
      itemType='http://schema.org/Episode'
    >
      <section itemProp='publisher' itemScope itemType='http://schema.org/Organization'>
        <meta itemProp='url' content='https://yokradio.com/' />
        <meta itemProp='name' content='Yok Radio' />
        <div itemProp='logo' itemScope itemType='http://schema.org/ImageObject'>
          <meta itemProp='url' content='https://yokradio.com/assets/icon/android-chrome-1024x1024.png' />
        </div>
      </section>

      <section className='identify'>
        <figure itemProp='image' itemScope itemType='http://schema.org/ImageObject'>
          <meta itemProp='contentUrl' content={chapter.itunes.image} />
          <IonImg
            src={chapter.itunes.image}
            alt={`Portada del capítulo ${chapter.title}`}
          />
        </figure>
        <figcaption>
          <p className='title'>
            {chapter?.itunes?.episode &&
              <span
                className='sequence-label'
              >
                {`${chapter.itunes.episode}. `}
              </span>}
            <span ng-bind='::' itemProp='name'>
              {chapter.title}
            </span>
          </p>
        </figcaption>
      </section>

      <section
        className='intro-container'
      >
        <SimpleBar autoHide={false} style={{ maxHeight: 150 }}>
          <p
            className='intro'
            itemProp='abstract'
          >
            {chapter.contentSnippet}
          </p>
        </SimpleBar>
      </section>

      <section className='controls'>
        <RssButton item={chapter} rssTitle={rssTitle} />
      </section>
    </div>
  )
}

export default RssChapterCard
